import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Repayment, EmiDue, Loan } from '../loans';
import { ClientJS } from 'clientjs';

@Injectable()
export class UtilService {

    public otherEmiShiftedSource = new Subject<boolean>();
    public arrearTextBelowQuickPaySource = new Subject<string>();
    public pendingTextBelowQuickPaySource = new Subject<string>();

    private lateFees: number;
    public nextEmiDueIndex: number;
    public otherEmiShifted = false;
    private oneDay = 24 * 60 * 60 * 1000;
    public pendingTextBelowQuickPay = '';
    public arrearTextBelowQuickPay = '';
    public otherEmiDues: any[];
    public amountToPay: number;
    public showPaymentStatus: boolean;
    public transactionId = '';
    public nextEmiDue = new EmiDue();
    public checkedEmi: any[];
    public quickPayClicked = false;
    public amountPaid: number;
    public selectedLoanRepayment: Loan;
    public emailDetails: string;
    public mobileDetails: string;
    public transactionStatus = 'payment-status pending';
    public RepaymentSource: string;
    public RepaymentMode: string;
    public modalDisplay: string;
    public zone: NgZone;
    public razorpayWindow: any;
    public type: string;
    public allTransactions: any;

    constructor() { }

    showStatus(loan) {
    if ((loan.Status === 'Approved') && loan.MerchantDetails) {
        return 'Activation Pending';
    } else {
        return loan.Status;
    }
    }

    getLateFees(repayments: Repayment[]): number {
    this.lateFees = 0;
    const d = new Date();
    d.setHours(0, 0, 0);
    if (repayments && repayments.length > 0) {
      for (let i = 0; i < repayments.length; i++) {
        const d1 = new Date(repayments[i].DueDate);
        d1.setHours(23, 59, 59);
        if (repayments[i].State.toLowerCase() !== 'paid' && d1 < d) {
          this.lateFees += (repayments[i].FeesDue - repayments[i].FeesPaid + repayments[i].PenaltyDue - repayments[i].PenaltyPaid);
        }
      }
    }
    return this.lateFees;
    }

    getNextEmiDue(repayments: Repayment[]): any {
    const emiDue = { 'amount': 0, 'date': null };
    const d = new Date();
    d.setHours(0, 0, 0);
    if (repayments && repayments.length > 0) {
        for (let i = 0; i < repayments.length; i++) {
        const d1 = new Date(repayments[i].DueDate);
        d1.setHours(23, 59, 59);
        let amount = 0;
        if (repayments[i].State.toLowerCase() !== 'paid' && d1 > d) {
            // diffDays1 = Math.floor(Math.abs((d1.getTime() - d.getTime()) / (oneDay)));
            amount = repayments[i].InterestDue + repayments[i].PrincipalDue - (repayments[i].InterestPaid + repayments[i].PrincipalPaid);
            emiDue.amount = amount;
            emiDue.date = d1.toString();
            // emiDue = repayments[i].InterestDue + repayments[i].PrincipalDue - (repayments[i].InterestPaid + repayments[i].PrincipalPaid);
            this.nextEmiDueIndex = i;
            break;
        } else if (repayments[i].State.toLowerCase() !== 'paid' && d1 <= d) {
            // diffDays1 = Math.floor(Math.abs((d1.getTime() - d.getTime()) / (oneDay)));
            amount = repayments[i].InterestDue + repayments[i].PrincipalDue - (repayments[i].InterestPaid + repayments[i].PrincipalPaid);
            emiDue.amount = amount;
            emiDue.date = d1.toString();
            this.nextEmiDueIndex = i;
        }
        }
    }
    return emiDue;
    }

    getOtherEmiDues(repayments: Repayment[]): any {
    let dueText = false;
    let arrearText = false;
    let diffDays = 0;
    const otherEmis = [];
    let emiDue = 0;
    let emiDueDate = null;
    const d = new Date();
    d.setHours(0, 0, 0);
    if (repayments && repayments.length > 0) {
        for (let i = 0; i < repayments.length; i++) {
        const d1 = new Date(repayments[i].DueDate);
        d1.setHours(23, 59, 59);
        let amount = 0;
        if (repayments[i].State.toLowerCase() !== 'paid' && d1 <= d) {
            amount = repayments[i].InterestDue + repayments[i].PrincipalDue - (repayments[i].InterestPaid + repayments[i].PrincipalPaid);
            otherEmis.push({ 'amount': amount, 'date': d1 });
            arrearText = true;
        } else if (repayments[i].State.toLowerCase() !== 'paid' && d1 > d) {
            if (this.nextEmiDueIndex === i) {
            emiDue = repayments[i].InterestDue + repayments[i].PrincipalDue - (repayments[i].InterestPaid + repayments[i].PrincipalPaid);
            dueText = true;
            emiDueDate = repayments[i].DueDate;
            break;
            } else if (this.nextEmiDueIndex !== i) {
            amount = repayments[i].InterestDue + repayments[i].PrincipalDue - (repayments[i].InterestPaid + repayments[i].PrincipalPaid);
            otherEmis.push({ 'amount': amount, 'date': d1 });
            }
        }
        }
    }
    if (emiDue === 0) {
        otherEmis.pop();
        this.otherEmiShifted = true;
        this.otherEmiShiftedSource.next(this.otherEmiShifted);
    }
    if (arrearText && otherEmis.length > 0) {
        const arrearDueDate = new Date(otherEmis[0].date);
        arrearDueDate.setHours(0, 0, 0);
        diffDays = Math.floor(Math.abs((arrearDueDate.getTime() - d.getTime()) / (this.oneDay)));
        if (diffDays === 0) {
        this.arrearTextBelowQuickPay = 'Overdue today';
        } else if (diffDays === 1) {
        this.arrearTextBelowQuickPay = 'Overdue for 1 day';
        } else {
        this.arrearTextBelowQuickPay = 'Overdue for ' + diffDays + ' days';
        }
        this.arrearTextBelowQuickPaySource.next(this.arrearTextBelowQuickPay);
    } else if (!arrearText && dueText) {
        diffDays = Math.floor(Math.abs((new Date(emiDueDate).getTime() - d.getTime()) / (this.oneDay)));
        if (diffDays === 0) {
        this.pendingTextBelowQuickPay = 'Due today';
        } else if (diffDays === 1) {
        this.pendingTextBelowQuickPay = 'Due in 1 day';
        } else {
        this.pendingTextBelowQuickPay = 'Due in ' + diffDays + ' days';
        }
        this.pendingTextBelowQuickPaySource.next(this.pendingTextBelowQuickPay);
    }
    return otherEmis;
    }

    getAmountToPay(data, otherEmiDues): number {
    let totalAmount = 0;
    for (let i = 0; i < otherEmiDues.length; i++) {
        totalAmount = totalAmount + otherEmiDues[i].amount;
    }
    totalAmount += (this.lateFees + data.amount);
    return totalAmount;
    }

    getBrowserName = () => {
        const GOOGLE_VENDOR_NAME = 'Google Inc.';
        const userAgent = navigator && navigator.userAgent;
        const vendor = navigator && navigator.vendor;
        switch (true) {
          case /Edge|Edg|EdgiOS/.test(userAgent):
            return 'Edge';
          case /OPR|Opera/.test(userAgent):
            return 'Opera';
          case /CriOS/.test(userAgent):
          case /Chrome/.test(userAgent) && vendor === GOOGLE_VENDOR_NAME:
            return 'Chrome';
          case /Vivaldi/.test(userAgent):
            return 'Vivaldi';
          case /YaBrowser/.test(userAgent):
            return 'Yandex';
          case /Firefox|FxiOS/.test(userAgent):
            return 'Firefox';
          case /Safari/.test(userAgent):
            return 'Safari';
          case /MSIE|Trident/.test(userAgent):
            return 'Internet Explorer';
          default:
            return 'Unknown';
        }
    }

    getOS = () => {
        const userAgent = window.navigator.userAgent.toLowerCase(),
        macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
        windowsPlatforms = /(win32|win64|windows|wince)/i,
        iosPlatforms = /(iphone|ipad|ipod)/i;
        let os = null;
        if (macosPlatforms.test(userAgent)) {
          os = 'Mac OS';
        } else if (iosPlatforms.test(userAgent)) {
          os = 'IOS';
        } else if (windowsPlatforms.test(userAgent)) {
          os = 'Windows';
        } else if (/android/.test(userAgent)) {
          os = 'Android';
        } else if (!os && /linux/.test(userAgent)) {
          os = 'Linux';
        }
        return os;
      }

    getDeviceId = () => {
        const client = new ClientJS();
        const fingerprint = client.getFingerprint();
        return fingerprint;
    }
}
